const ADMIN_ROLE_NAMES = [
    'admin',
    'administrator',
    'superadmin',
    'super_admin',
    'super_user',
    'superuser',
];

function normalizeRole(value) {
    return value.trim().toLowerCase().replace(/[\s-]+/g, '_');
}

function isAdminFlag(value) {
    if (value === true || value === 1) {
        return true;
    }

    if (typeof value !== 'string') {
        return false;
    }

    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === '1';
}

function isAdminRole(value) {
    if (typeof value !== 'string') {
        return false;
    }

    const normalized = normalizeRole(value);
    return ADMIN_ROLE_NAMES.includes(normalized);
}

function isAdminCollection(value) {
    if (!value) {
        return false;
    }

    if (Array.isArray(value)) {
        return value.some(item => {
            if (typeof item === 'object' && item !== null) {
                return isAdminRole(item.name)
                    || isAdminRole(item.role)
                    || isAdminRole(item.value)
                    || isAdminRole(item.code);
            }

            return isAdminRole(item);
        });
    }

    if (typeof value === 'object') {
        return Object.keys(value).some(key => isAdminRole(key) && !!value[key]);
    }

    return isAdminRole(value);
}

export function isAdminUser(user = {}) {
    const developer = user.developer || {};

    return [
        user.isAdmin,
        user.admin,
        user.is_admin,
        user.isAdministrator,
        developer.isAdmin,
        developer.admin,
        developer.is_admin,
        developer.isAdministrator,
    ].some(isAdminFlag) || [
        user.role,
        user.userRole,
        user.type,
        developer.role,
        developer.userRole,
        developer.type,
    ].some(isAdminRole) || [
        user.roles,
        user.permissions,
        user.permission,
        developer.roles,
        developer.permissions,
        developer.permission,
    ].some(isAdminCollection);
}
